(function () {
  'use strict';

  if (customElements.get('certificates-v2-section')) return;

  class CertificatesV2Section extends HTMLElement {
    constructor() {
      super();
      this._modal = null;
      this._modalImg = null;
      this._swiper = null;
      this._handleKeydown = this._handleKeydown.bind(this);
    }

    connectedCallback() {
      this._modal    = this.querySelector('.certificates-v2__modal');
      this._modalImg = this.querySelector('.certificates-v2__modal-img');

      this._setupModal();

      if (this.dataset.mode === 'slider') {
        this._initSlider();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._handleKeydown);
      if (this._swiper) {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }
    }

    /* ---- Modal ---- */

    _setupModal() {
      if (this.dataset.enableModal === 'false') return;

      this.querySelectorAll('.certificates-v2__logo-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const src = btn.dataset.fullSrc;
          const alt = btn.dataset.fullAlt || '';
          if (src && this._modal && this._modalImg) {
            this._modalImg.src = src;
            this._modalImg.alt = alt;
            this._openModal();
          }
        });
      });

      const backdrop = this.querySelector('.certificates-v2__modal-backdrop');
      if (backdrop) {
        backdrop.addEventListener('click', () => this._closeModal());
      }

      const closeBtn = this.querySelector('.certificates-v2__modal-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this._closeModal());
      }
    }

    _openModal() {
      if (!this._modal) return;
      this._modal.setAttribute('aria-hidden', 'false');
      this._modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._handleKeydown);

      const closeBtn = this._modal.querySelector('.certificates-v2__modal-close');
      if (closeBtn) closeBtn.focus();
    }

    _closeModal() {
      if (!this._modal) return;
      this._modal.setAttribute('aria-hidden', 'true');
      this._modal.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this._handleKeydown);
    }

    _handleKeydown(e) {
      if (e.key === 'Escape') this._closeModal();
    }

    /* ---- Slider ---- */

    _initSlider() {
      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      const doInit = () => {
        window.loadThemeSwiper().then(() => {
          this._createSwiper(swiperEl);
        }).catch((err) => {
          console.warn('[CertificatesV2] Swiper failed to load:', err);
        });
      };

      if (window.theme && typeof window.theme.whenVisible === 'function') {
        window.theme.whenVisible(this, doInit);
      } else {
        doInit();
      }
    }

    _createSwiper(swiperEl) {
      if (this._swiper) {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }

      const navPrev = this.querySelector('.certificates-v2__nav-btn--prev');
      const navNext = this.querySelector('.certificates-v2__nav-btn--next');

      const slidesDesktop = parseInt(this.dataset.slidesDesktop)       || 7;
      const slidesTablet  = parseInt(this.dataset.slidesTablet)        || 5;
      const slidesMobile  = parseInt(this.dataset.slidesMobile)        || 2;
      const spaceBetween  = parseInt(this.dataset.spaceBetween)        || 24;
      const spaceMobile   = parseInt(this.dataset.spaceBetweenMobile)  || 16;
      const loop          = this.dataset.loop !== 'false';
      const speed         = parseInt(this.dataset.speed)               || 400;
      const autoplay      = this.dataset.autoplay === 'true'
        ? { delay: parseInt(this.dataset.autoplayDelay) || 4000, disableOnInteraction: true, pauseOnMouseEnter: true }
        : false;

      this._swiper = new Swiper(swiperEl, {
        slidesPerView: slidesDesktop,
        spaceBetween: spaceBetween,
        loop: loop,
        speed: speed,
        navigation: (navPrev && navNext) ? { prevEl: navPrev, nextEl: navNext } : false,
        autoplay: autoplay,
        breakpoints: {
          0: {
            slidesPerView: slidesMobile,
            spaceBetween: spaceMobile
          },
          640: {
            slidesPerView: slidesTablet,
            spaceBetween: spaceBetween
          },
          1024: {
            slidesPerView: slidesDesktop,
            spaceBetween: spaceBetween
          }
        }
      });
    }
  }

  customElements.define('certificates-v2-section', CertificatesV2Section);

  /* Theme Editor hot-reload: re-run setup when section reloads */
  document.addEventListener('shopify:section:load', function (e) {
    const el = e.target.querySelector('certificates-v2-section');
    if (!el) return;
    /* Custom element lifecycle handles re-init automatically on connectedCallback */
  });
})();
